module.exports = __webpack_public_path__ + "img/1508265935.7a88971f.jpg";